import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { FaBars } from 'react-icons/fa';
import Sidebar from './Sidebar';
import AppColors from '../../utils/AppColors';

const MainContainer = styled(Box)(({ sidebaropen }) => ({
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: `linear-gradient(135deg, ${AppColors.primaryYellow} 0%, ${AppColors.primaryDark} 100%)`,
    backgroundAttachment: 'fixed',
}));

const ContentContainer = styled(Box)(({ sidebaropen }) => ({
    marginLeft: sidebaropen === 'true' ? '220px' : '70px',
    width: sidebaropen === 'true' ? 'calc(100% - 220px)' : 'calc(100% - 70px)',
    transition: 'all 0.3s ease',
    overflow: 'auto',
}));

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <MainContainer sidebaropen={sidebarOpen.toString()}>
            <Sidebar isOpen={sidebarOpen} />
            <ContentContainer sidebaropen={sidebarOpen.toString()}>
                <Box sx={{ p: 2 }}>
                    <IconButton 
                        onClick={toggleSidebar}
                        sx={{
                            position: 'fixed',
                            top: 16,
                            left: sidebarOpen ? 236 : 86,
                            zIndex: 1100,
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                            }
                        }}
                    >
                        <FaBars />
                    </IconButton>
                    <Box sx={{ mt: 6 }}>
                        {children}
                    </Box>
                </Box>
            </ContentContainer>
        </MainContainer>
    );
};

export default Layout;
